import type { LinkXHRData } from './types'

export function isLinkXHRData(data: unknown): data is LinkXHRData {
  return Array.isArray(data) && (data.length === 2 || data.length === 3)
}
